import React from "react";
import "./PLMERPDataAndProcessManagement.css";
import PLMERPDataOverview from "./PLMERPDataOverview";
import BannerImage from "../../../assets/other_image/PLM_ERP.jpg";
import Letsgetintouch from "../BusinessProcessAndChangeManagement/Letsgetintouch";
import { NavLink } from "react-router-dom";
import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";

const PLMERPDataAndProcessManagement = () => {
  return (
    <section className="PLMERPData-management">
      <Banner
        image={BannerImage} // Pass the image for this page
        heading="Teamcenter PLM – ERP Data and Process Management" // Pass the heading text for this page
      />
      <div>
         <FloatingContactUs />
      </div>
      

      <PLMERPDataOverview />
      <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
          <h4 className="PLMERPData-page-heading">Unlock the Power :</h4>
          <h5 className="PLMERPData-subheading">
            Discover the Transformative Benefits of PLM – ERP Data and Process Management with NexTech!
          </h5>
          <ul className="custom-bullets">
            <li>
              Efficient collaboration with seamless data transfer between the
              PLM and ERP system{" "}
            </li>
            <li>
              Consistency of BOM, product change, and other related information
              used throughout the enterprise{" "}
            </li>
            <li>
              Integral business processes for engineering change orders (ECOs)
              to control BOM changes between the systems
            </li>
          </ul>
        </div>
      </section>
      <section>
        <div className="solutions container">
          <div className="solutions-content">
            <div className="row">
              <div className="col-md-6 col-12">
                <h4 className="PLMERPData-page-heading">Teamcenter Solutions</h4>

                <ul className="custom-bullets">
                  <li>T4S, T40, and T4EA Installation </li>
                  <li>
                    Data flow modelling for business object and their lifecycle{" "}
                  </li>
                  <li>TCL programming for mapping </li>
                  <li>T4S_Gateway explorer configuration </li>
                  <li>
                    Data Model Mapping of Teamcenter and SAP business objects{" "}
                  </li>
                  <li>Teamcenter and SAP Login configuration </li>
                  <li>Configuration for MM & MBOM transfer </li>
                  <li>
                    Workflow Development for automatic transfer of MM & MBOM on
                    receiving maturity{" "}
                  </li>
                  <li>
                    Change management across the SAP & Teamcenter workflow
                    development{" "}
                  </li>
                </ul>
              </div>

              <div className="col-md-6 col-12">
                <div className="quick-links">
                  <h4>Quick Links</h4>
                  <ul>
                    <li>
                      <NavLink
                        to={"/teamcenter/product-bom-variability-management"}
                      >
                        Product BOM and Variability Management
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/community-collaboration"}>
                        Teamcenter Community Collaboration
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/cybersecurity"}>
                        Teamcenter Cyber security
                      </NavLink>
                    </li>

                    <li>
                      <NavLink to={"/teamcenter/cloud-implementation"}>
                        Teamcenter Implementation on Cloud
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/implementation"}>
                        Teamcenter Implementation
                      </NavLink>
                    </li>

                    <li>
                      <NavLink to={"/teamcenter/cae-integration"}>
                        Teamcenter Integration for CAE
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/cam-integration"}>
                        Teamcenter Integration for CAM
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={"/teamcenter/performance-tuning-health-checkup"}
                      >
                        Teamcenter Performance Tuning & Health Check-up
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={"/teamcenter/program-project-management"}>
                        Teamcenter Project Management
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section style={{ background: "#f5f7fa" }}>
        <div className="best-practices container">
          <h4 className="PLMERPData-page-heading">Best Practices</h4>
          <p className="plmimplementationparagraph">
            We help customer to implement and usage of modules like SAP
            materials management, SAP document management, SAP Bill of
            Materials, SAP change management, SAP routing, SAP equipment, SAP
            functional location, SAP vendor management using T4S efficiently
            which involves various activities. Need to shift ownership of
            product structure and bills of material (BOMs) from Manufacturing to
            Engineering.
          </p>
          <p className="plmimplementationparagraph">
            ERP systems do not have integral processes for engineering change
            orders (ECOs) and cannot be used to control BOM changes or manage
            associated files However, BOM information must still be supported
            and accessible from within ERP applications, this increases the
            importance of integrating PLM and ERP to ensure consistency of BOM,
            product change, and other related information used throughout the
            enterprise.
          </p>
          <p className="plmimplementationparagraph">
            Operations, manufacturing and finance typically use Enterprise
            Resource Planning (ERP) systems to track materials planning,
            sourcing, and other production related information. Engineering
            groups are often not inclined to use ERP systems unless absolutely
            necessary While a manufacturing BOM and associated item data are
            usually loaded into an ERP system to manage production sourcing and
            costs, ERP systems are not designed to be change control or file
            management tools, Consequently, all changes to items and BOMs have
            to be recorded, approved and tracked outside the ERP system.
          </p>
        </div>
      </section>
      <section>
        <div className="why-nextech container">
          <h4 className="PLMERPData-page-heading">Why NexTech?</h4>
          <h5 className="PLMERPData-subheading">
            For PLM-ERP Data and Process Management
          </h5>
          <ul className="custom-bullets">
            <li>
              Expertise in seamless integration and configuration of Teamcenter
              Integration for ERP systems like SAP, HANA, Oracle, and Microsoft
              Dynamics, ensuring bidirectional transfer of critical data and
              processes.
            </li>
            <li>
              Proficiency in establishing best practices for materials
              management, document management, Bill of Materials (BOM), change
              management, routing, equipment, functional location, and vendor
              management using integration frameworks such as T4S, T40, and
              T4EA.
            </li>
            <li>
              Comprehensive offerings including T4S installation, data flow
              modeling, TCL programming for mapping, configuration for MM & MBOM
              transfer, and workflow development for automatic transfer of MM &
              MBOM.
            </li>
            <li>
              Ensuring efficient collaboration and consistency of data across
              PLM and ERP systems, enabling integral business processes for
              engineering change orders (ECOs) and controlled BOM changes.
            </li>
            <li>
              Dedicated support for configuring login, data model mapping, and
              workflow development across SAP & Teamcenter environments,
              ensuring smooth integration and streamlined operations.
            </li>
          </ul>
        </div>
      </section>
      <Letsgetintouch />
    </section>
  );
};

export default PLMERPDataAndProcessManagement;
